<template>
  <span class="text-primary text-xs font-semibold uppercase leading-none mb-2">
    <slot></slot>
  </span>
</template>

<script>
export default {}
</script>
